var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

//      


var defaultSetPayload = function defaultSetPayload(action, payload) {
  return _extends({}, action, {
    payload: payload
  });
};
var defaultGetPayload = function defaultGetPayload(action) {
  return action.payload;
};
var defaultGetError = function defaultGetError(action) {
  return action.payload;
};

function createListener() {
  var nextListenerId = 0;
  var listeners = {};
  var dispatch = void 0;
  var middleware = function middleware(store) {
    dispatch = store.dispatch;
    return function (next) {
      return function (action) {
        // This could potentially be improved performance-wise by doing a hash lookup
        // by action.type to not loop through all the listeners on every action,
        // but there will probably be no listeners for the majority of an application's
        // lifecycle, so this structure was chosen for its ease of cleanup.
        Object.keys(listeners).forEach(function (key) {
          return listeners[Number(key)](action);
        });
        return next(action);
      };
    };
  };

  var createAsyncFunction = function createAsyncFunction(config) {
    var listenerId = nextListenerId++;
    var unsubscribe = function unsubscribe() {
      delete listeners[listenerId];
    };
    if (!dispatch) {
      throw new Error('The redux-promise-listener middleware is not installed');
    }
    var asyncFunction = function asyncFunction(payload) {
      return new Promise(function (resolve, reject) {
        var listener = function listener(action) {
          if (action.type === config.resolve || typeof config.resolve === 'function' && config.resolve(action)) {
            unsubscribe();
            resolve((config.getPayload || defaultGetPayload)(action));
          } else if (action.type === config.reject || typeof config.reject === 'function' && config.reject(action)) {
            unsubscribe();
            reject((config.getError || defaultGetError)(action));
          }
        };
        listeners[listenerId] = listener;
        dispatch((config.setPayload || defaultSetPayload)({ type: config.start }, payload));
      });
    };

    return { asyncFunction: asyncFunction, unsubscribe: unsubscribe };
  };

  return { middleware: middleware, createAsyncFunction: createAsyncFunction };
}

//

export default createListener;
